export default __webpack_public_path__ + "static/media/c42738f5524642434ad2b0358d31a352.png";